import "./EditTrialDescriptionModal.scss";

import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ClipLoader } from "react-spinners";
import { X } from "lucide-react";
import api from "../../../config/api.config";
import { api_url } from "../../../config/api-endpoint";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

interface IModalProps {
  handleCloseModal: (val: boolean) => void;
  lessonId: string;
  currentDescription: string;
}

const EditTrialDescriptionModal = ({
  handleCloseModal,
  lessonId,
  currentDescription,
}: IModalProps) => {
  const [description, setDescription] = useState(currentDescription);
  const [isPending, setIsPending] = useState(false);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const merchantId = localStorage.getItem("teacherId");

  const updateDescriptionMutation = useMutation({
    mutationFn: async (newDescription: string) => {
      const { data } = await api.patch(
        `${api_url}/lessons/trail-lesson/${lessonId}`,
        { description: newDescription },
      );
      return data;
    },
    onSuccess: () => {
      toast.success("Trial lesson description updated successfully.", {
        richColors: true,
      });

      queryClient.invalidateQueries({
        queryKey: ["fetchTrialLesson", merchantId],
      });

      handleCloseModal(true);
      window.location.reload();
    },
    onError: (error: any) => {
      toast.error(error.message ?? "Error updating trial lesson description");
    },
    onSettled: () => {
      setIsPending(false);
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsPending(true);
    await updateDescriptionMutation.mutateAsync(description);
  };

  return (
    <div className="editTrialModal">
      <form onSubmit={handleSubmit} className="modalForm">
        <h2 className="sectionTitle">Edit Trial Lesson Description</h2>
        <X className="closeModal" onClick={() => handleCloseModal(true)} />

        <label className="formLabel">
          Lesson Description
          <textarea
            name="description"
            required
            placeholder="Update lesson description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>

        <div className="modalActions">
          <button
            type="button"
            onClick={() => handleCloseModal(true)}
            className="discardButton"
          >
            Cancel
          </button>
          <button type="submit" className="saveButton" disabled={isPending}>
            {isPending ? (
              <span>
                <ClipLoader color="white" size={15} /> Saving
              </span>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditTrialDescriptionModal;
